<script setup lang="ts">
import type { NovaCalendarSlotsProps } from './NovaCalendarSlots.types'

defineProps<NovaCalendarSlotsProps>()
</script>

<template>
  <div class="calendar-slots-container">
    <NovaCalendarWeekDays :weekdays="weekdays" />

    <div class="calendar-slots grid-wrapper grid-7 gap-14">
      <NovaCalendarSlot
        v-for="calendarSlot in calendarSlots"
        :key="calendarSlot.date"
        :calendar-slot="calendarSlot"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.calendar-slots-container {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-bottom: 24px;

  @include mobile {
    padding-bottom: 12px;
  }

  .calendar-slots {
    flex-grow: 1;

    @include mobile {
      grid-gap: 4px;
      grid-row-gap: 12px;
      padding: 0 8px;
    }
  }
}
</style>
